import { apiRequest } from '@/utils/request'

// 获取业务网点列表
export function getBusinessNetworkList(queryParams) {
  return apiRequest({
    url: '/BusinessNetwork/GetList',
    method: 'get',
    params: queryParams
  })
}
